// extracted by mini-css-extract-plugin
export default {"swatch":"Swatch_swatch__Umv4C","swatchSmall":"Swatch_swatchSmall__4zCww","swatchLarge":"Swatch_swatchLarge__14cMI","swatchUnknown":"Swatch_swatchUnknown__VRWdr"};